var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTargetSignsOfSkinAging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.852,
    height: 84.821,
    viewBox: "0 0 74.852 84.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19542 19288.324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.383,51.052c-.1.446-.439.544-1.743,1.45a4.777,4.777,0,0,1-4.9,0c-1.3-.906-1.639-1-1.743-1.45",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.96,37.4a3.321,3.321,0,0,1,4.088.022,7.972,7.972,0,0,0,3.406,1.742,8.333,8.333,0,0,0,2.681.141,19.655,19.655,0,0,0,3.529-.847c.833-.234,1.533-.434,2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.245,40.653a3.19,3.19,0,0,1,2.507-1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.24,37.4a3.322,3.322,0,0,0-4.089.022,7.966,7.966,0,0,1-3.406,1.742,8.333,8.333,0,0,1-2.681.141,19.654,19.654,0,0,1-3.529-.847c-.833-.234-1.532-.434-2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.448,38.959a3.19,3.19,0,0,1,2.507,1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.942,19.283c.2,6.293-.736,30.857.679,36.191,2.482,9.324,13.7,18.48,20.754,23.456a9.984,9.984,0,0,0,11.674,0,49.561,49.561,0,0,0,5.288-3.979",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.613,29.741a8.669,8.669,0,0,0-5.187-2.767,28.444,28.444,0,0,0-8.127,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.679,29.7a8.669,8.669,0,0,1,5.187-2.767,28.444,28.444,0,0,1,8.127,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.06,5.618A165.335,165.335,0,0,1,351.676,16.48c10.5,9.683,18.069,23.972,24.264,41.646",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 12.251,
    x2: 23.059,
    transform: "translate(-19534.059 -19281.293)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.228,
    x2: 8.049,
    transform: "translate(-19506.939 -19285.936)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.073,
    x2: 7.662,
    transform: "translate(-19494.283 -19275.781)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.283,
    x2: 3.201,
    transform: "translate(-19479.521 -19255.77)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.812,
    x2: 4.518,
    transform: "translate(-19483.469 -19262.564)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.718,
    x2: 1.792,
    transform: "translate(-19475.703 -19249.236)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.877,
    x2: 2.188,
    transform: "translate(-19473.676 -19242.734)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.505,
    x2: 1.26,
    transform: "translate(-19470.965 -19236.463)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.255,
    x2: 5.624,
    transform: "translate(-19488 -19269.58)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.265,
    x2: 8.143,
    transform: "translate(-19499.123 -19281.619)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.374,65.3a1.374,1.374,0,0,1-.331-.064c.029-.04.043-.062.043-.062l-.2,0c-1.614-.708-2.965-4.189-3.942-4.565a7.888,7.888,0,0,0-2.32.392c-.392.114-1.8-.621-2.14-.441-.663.347-1.144,1.487-1.618,2.565a5.858,5.858,0,0,1-1.824,2.217h-.016l.006.007c-.1.071.15.174.15.174.827,1.014,2.182,3.284,6,3.166,3.239-.1,5.35-2.754,5.806-3.384Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.822,25.125c-1.136,3.689-6.322,7.343-6.322,14.176s1.547,8.7,5.074,8.7",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.067,43.435c-.572,3.063-1.9,3.065-3.278,3.065a1.5,1.5,0,0,0,0,3c2.414,0,3.976-.8,4.97-2.221q-.83-1.958-1.692-3.844",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.741,30.983V15.563l1.657-1.078,20.816-11.06",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.354,64.871a4.923,4.923,0,0,1-1.013,4.158",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.45,61.072a3.644,3.644,0,0,1,2.294,2.755",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.559,24.194a7.234,7.234,0,0,1,.631-5.334",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.4,23.819a8.879,8.879,0,0,1,2.127-2.668",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.739,44.635a6.909,6.909,0,0,0,9.28-.192",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.028,41.418a2.909,2.909,0,0,0,1.607.458c.562-.065,1.1-.618.929-1.157",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.35,56.453a14.648,14.648,0,0,0-.6-7.9",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.871,16.1a5.547,5.547,0,0,1,4.623.826,16.055,16.055,0,0,1,3.465,3.373",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 83.821,
    transform: "translate(-19506.771 -19287.824)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.12,49.691A1.69,1.69,0,1,1,352.429,48a1.691,1.691,0,0,1,1.691,1.691",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.486,55.245a.757.757,0,1,1-.757-.757.757.757,0,0,1,.757.757",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.207,22.486a.757.757,0,1,1-.758-.757.758.758,0,0,1,.758.757",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.21,33.683c-.2,6.293.736,16.457-.679,21.791-2.482,9.324-13.7,18.48-20.754,23.456a9.987,9.987,0,0,1-11.674,0c-2.172-1.53-4.737-3.458-7.319-5.663",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetSignsOfSkinAging);
export default __webpack_public_path__ + "static/media/target-signs-of-skin-aging.a8077053.svg";
export { ForwardRef as ReactComponent };